class LoyaltyActivity extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.setAttribute('aria-busy', true)

    this.getDetails = this.getDetails.bind(this)

    document.addEventListener('swell:setup', () => {
      this.getDetails()
    })
  }

  getDetails () {
    /* eslint-disable-next-line no-undef */
    const customerDetails = swellAPI.getCustomerDetails()
    const actionHistoryItems = customerDetails.actionHistoryItems

    if (actionHistoryItems.length > 0) {
      this.renderTable(actionHistoryItems)
    } else {
      this.renderNoResults()
    }

    this.setAttribute('aria-busy', false)
  }

  formatDateUK (timestamp) {
    const date = new Date(timestamp)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()

    return `${day}/${month}/${year}`
  }

  createTableTemplate (data) {
    const tableHeaders = `
      <thead>
        <tr>
          <th>Date</th>
          <th>Action</th>
          <th>Points</th>
          <th>Status</th>
        </tr>
      </thead>
    `

    const tableBody = data
      .map(
        (item) => `
      <tr>
        <td data-label="Date">${this.formatDateUK(item.createdAt)}</td>
        <td data-label="Action">${item.action}</td>
        <td data-label="Points">${item.points}</td>
        <td data-label="Status">${item.status || '-'}</td>
      </tr>
    `,
      )
      .join('')

    return `
      <table>
        ${tableHeaders}
        <tbody>
          ${tableBody}
        </tbody>
      </table>
    `
  }

  renderTable (data) {
    this.innerHTML = this.createTableTemplate(data)
  }

  renderNoResults () {
    this.innerHTML = `<p>You don't have any history to show at this time.</p>`
  }
}

if (!customElements.get('loyalty-activity')) {
  customElements.define('loyalty-activity', LoyaltyActivity)
}
